import { render, staticRenderFns } from "./InitialData.vue?vue&type=template&id=d2eb712c"
import script from "./InitialData.vue?vue&type=script&lang=js"
export * from "./InitialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports